import { formatDate } from "../utils/format-utils";
import store from "../store/index";

import Provider from "./Provider";
import Client from "./Client";
import School from "./School";

export default class Assignment {
  assignmentId?: number | null;
  legacyActionId?: number | null;
  servicePlanId?: number | null;
  planTypeId?: number | null;
  providerId?: number | null;
  provider?: Provider | null;
  clientId?: number | null;
  client?: Client | null;
  school?: School | null;
  programId?: number | null;
  program?: string | null;
  serviceId?: number | null;
  service?: string | null;
  approvalStartDate?: Date | null;
  approvalEndDate?: Date | null;
  startDate?: Date | null;
  endDate?: Date | null;
  providerSpecGroupSize?: number | null;
  providerSpecDurationMinutes?: number | null;
  providerSpecFrequency?: number | null;
  providerSpecLocationId?: number | null;
  providerSpecLocation?: string | null;
  isSubstitute?: boolean | null;
  lastNotificationSentAt?: Date | null;

  public constructor(params: Assignment = {} as Assignment) {
    let {
      assignmentId = 0,
      legacyActionId = 0,
      servicePlanId = null,
      planTypeId = null,
      providerId = null,
      provider = null,
      clientId = null,
      client = null,
      school = null,
      programId = null,
      program = null,
      serviceId = null,
      service = null,
      approvalStartDate = null,
      approvalEndDate = null,
      startDate = null,
      endDate = null,
      providerSpecGroupSize = null,
      providerSpecDurationMinutes = null,
      providerSpecFrequency = null,
      providerSpecLocationId = null,
      providerSpecLocation = null,
      isSubstitute = null,
      lastNotificationSentAt = null,
    } = params;
    this.assignmentId = assignmentId;
    this.legacyActionId = legacyActionId;
    this.servicePlanId = servicePlanId;
    this.planTypeId = planTypeId;
    this.providerId = providerId;
    this.provider = provider && new Provider(provider);
    this.clientId = clientId;
    this.client = client && new Client(client);
    this.school = school && new School(school);
    this.programId = programId;
    this.program = program;
    this.serviceId = serviceId;
    this.service = service;
    this.approvalStartDate = approvalStartDate && new Date(approvalStartDate);
    this.approvalEndDate = approvalEndDate && new Date(approvalEndDate);
    this.startDate = startDate && new Date(startDate);
    this.endDate = endDate && new Date(endDate);
    this.providerSpecGroupSize = providerSpecGroupSize;
    this.providerSpecDurationMinutes = providerSpecDurationMinutes;
    this.providerSpecFrequency = providerSpecFrequency;
    this.providerSpecLocationId = providerSpecLocationId;
    this.providerSpecLocation = providerSpecLocation;
    this.isSubstitute = isSubstitute;
    this.lastNotificationSentAt = lastNotificationSentAt;
  }
  get formattedApprovalStartDate() {
    return formatDate(this.approvalStartDate);
  }
  get formattedApprovalEndDate() {
    return formatDate(this.approvalEndDate);
  }
  get formattedStartDate() {
    return formatDate(this.startDate);
  }
  get formattedEndDate() {
    return formatDate(this.endDate);
  }
  get providerName() {
    return this.provider?.firstName + " " + this.provider?.lastName;
  }
  get mandate() {
    if (
      Boolean(this.providerSpecFrequency) &&
      Boolean(this.providerSpecDurationMinutes)
    )
      return (
        this.providerSpecFrequency +
        " x " +
        this.providerSpecDurationMinutes +
        " : " +
        this.providerSpecGroupSize
      );
    return "";
  }
  // only resolve semester for semester-based plans
  get semester() {
    if (
      !store.getters["optionsModule/getIsSemesterBasedPlanType"](
        this.planTypeId
      )
    )
      return null;
    return store.getters["optionsModule/getSemesterByDate"](
      this.approvalStartDate
    );
  }
  get formattedLastNotificationSentAt() {
    return formatDate(this.lastNotificationSentAt);
  }
  get timeframe() {
    let today = new Date();
    today.setHours(0, 0, 0, 0);
    // assignment dates fall back to the plan's approval dates when null
    let start = this.startDate ?? this.approvalStartDate;
    let end = this.endDate ?? this.approvalEndDate;

    if (end != null && end < today) {
      return "previous";
    } else if (
      start != null &&
      start <= today &&
      (end == null || end >= today)
    ) {
      return "current";
    } else if (start == null || start >= today) {
      return "upcoming";
    } else {
      return "";
    }
  }
}
